import { useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

import DangerZoneSettings from "../components/settings/DangerZoneSettings";
import { PaymentsSettingsTab } from "../components/settings/PaymentsSettingsTab";
import AccountPage from "./Account";
import BrandingPage from "./BrandingPage";
import StaffPage from "./Staff";
import ServicesPage from "./Services";
import NotificationSettingsPage from "./NotificationSettingsPage";
import { VoiceSettingsTab } from "../components/settings/VoiceSettingsTab";

import {
  Box,
  Typography,
  Tab,
  Tabs,
  Paper,
} from "@mui/material";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

const TABS = [
  { key: "account",       label: "Account" },
  { key: "branding",      label: "Branding" },
  { key: "staff",         label: "Staff" },
  { key: "services",      label: "Services" },
  { key: "notifications", label: "Notifications" },
  { key: "voice",         label: "AI assistant" },
  { key: "payments",      label: "Payments" },
  { key: "advanced",      label: "Advanced" },
];

const Settings = () => {
  const { currentUser } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab") ?? "account";
  const activeTab = TABS.find((t) => t.key === tabParam)?.key ?? "account";

  const handleTabChange = (_: React.SyntheticEvent, newKey: string) => {
    setSearchParams({ tab: newKey });
  };

  return (
    <Box>
      {/* Header */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 3 }}>
        <SettingsOutlinedIcon sx={{ color: "#C9734F", fontSize: 28 }} />
        <Typography variant="h5" sx={{ fontWeight: 700, color: "#0F172A" }}>
          Settings
        </Typography>
      </Box>

      {/* Tab bar */}
      <Paper
        elevation={0}
        sx={{
          borderRadius: "14px",
          border: "1px solid #E2E8F0",
          backgroundColor: "#fff",
          mb: 3,
          overflow: "hidden",
        }}
      >
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            px: 2,
            borderBottom: "1px solid #F1F5F9",
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 500,
              fontSize: "0.875rem",
              color: "#64748B",
              minHeight: 48,
              "&.Mui-selected": {
                color: "#C9734F",
                fontWeight: 600,
              },
            },
            "& .MuiTabs-indicator": {
              backgroundColor: "#C9734F",
              height: 2,
              borderRadius: "2px 2px 0 0",
            },
          }}
        >
          {TABS.map((tab) => (
            <Tab key={tab.key} label={tab.label} value={tab.key} />
          ))}
        </Tabs>
      </Paper>

      {/* Tab content */}
      {activeTab === "account" && <AccountPage />}
      {activeTab === "branding" && <BrandingPage />}
      {activeTab === "staff" && <StaffPage />}
      {activeTab === "services" && <ServicesPage />}
      {activeTab === "notifications" && <NotificationSettingsPage />}
      {activeTab === "voice" && <VoiceSettingsTab />}
      {activeTab === "payments" && <PaymentsSettingsTab />}
      {activeTab === "advanced" && (
        <Paper
          elevation={0}
          sx={{
            p: 3,
            borderRadius: "14px",
            border: "1px solid #E2E8F0",
            backgroundColor: "#fff",
            maxWidth: 600,
          }}
        >
          <DangerZoneSettings currentUser={currentUser} />
        </Paper>
      )}
    </Box>
  );
};

export default Settings;
